var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaylistsInfluencers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5034 40.848L29.8494 39.9961L19.7014 45.222L21.6394 34.1574L13.4791 26.3608L24.758 24.7566L29.8444 14.6485L34.9309 24.7566L46.2098 26.3608L41.6962 30.675L45.2034 32.7026L54.6889 23.6407L37.4916 21.1896L29.8444 6L22.1973 21.1896L5 23.6407L17.4446 35.5323L14.5153 52.2663L29.8394 44.3701L31.4934 45.222V40.848H31.5034ZM39.28 38.2524V47.2596L47.0617 42.756L39.28 38.2524ZM35.3942 54V31.512L54.8284 42.756L35.3942 54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistsInfluencers);
export default __webpack_public_path__ + "static/media/playlistsInfluencers.589124d8.svg";
export { ForwardRef as ReactComponent };